declare global {
    interface Window {
        dataLayer: any[];
    }
}

export function sendGA4Event(event: Record<string, unknown>) {
    if ("google_tag_manager" in window && event) {
        window.dataLayer.push(event);
    }
}
